import { SVGProps } from 'react';

export const ChevronIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg data-icon width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        className="stroke-fletchers-green-500"
        d="M1 1L4 4L7 1"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};
